import { render, staticRenderFns } from "./SmallCategoryList.vue?vue&type=template&id=14375ddf&"
import script from "./SmallCategoryList.vue?vue&type=script&lang=js&"
export * from "./SmallCategoryList.vue?vue&type=script&lang=js&"
import style0 from "./SmallCategoryList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports